import * as React from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { useResponsive } from "../../../hooks/useResponsive";
import { setActiveBoards } from "../../../redux/ActiveBoardSlice";
import { useBoards } from "../../../reactQuery/boards";
import { getActiveBoards } from "../utils/myTaskUtils";

export function useMyTaskHeaderState(currentTab) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterDrawer, setFilterDrawer] = React.useState(false);
  const isMobile = useResponsive("down", "md");
  const { boards } = useBoards();
  const dispatch = useDispatch();
  const tab = searchParams.get("tab");
  const shouldShowFilter = currentTab !== "my-planner";

  React.useEffect(() => {
    if (tab === "mine") {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set("tab", "mine");
      setSearchParams(newSearchParams);
    }
  }, [searchParams, setSearchParams, tab]);

  React.useEffect(() => {
    dispatch(setActiveBoards(getActiveBoards(boards?.data?.data?.responseData)));
  }, [boards, dispatch]);

  const openFilterDrawer = React.useCallback(() => {
    setFilterDrawer(true);
  }, []);

  const closeFilterDrawer = React.useCallback(() => {
    setFilterDrawer(false);
  }, []);

  return {
    isMobile,
    filterDrawer,
    shouldShowFilter,
    openFilterDrawer,
    closeFilterDrawer,
  };
}
